import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { Project } from 'src/app/models/Project';
import { Customer } from 'src/app/models/Customer';
import { HomeElement } from 'src/app/models/HomepageElement';
import { WorkWithUs } from 'src/app/models/WorkWithUs';
import { Translate } from 'src/app/pipe/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {
  projects: Project[];
  customers: Customer[];
  home: HomeElement[];
  workWithUs: WorkWithUs[];
  section: string;
  constructor(private service: ApiService, private translate: Translate,
    private route: ActivatedRoute, private router: Router) { }

  async ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.section = params.get('section');
      if (this.section)
        setTimeout(() => this.scroll(this.section), 150);
    });
    this.home = await this.service.getHomepageList();
  }
  getBrochureName() {
    let name = this.translate.transform("BROCHURE_NAME", 'pipeFilter') as string;
    return "../../../assets/download/" + name + ".pdf";
  }
  scroll(id: string, attempts: number = 0) {
    const element = document.getElementById(id);
    if (!element) {
      if (attempts < 20)
        setTimeout(() => this.scroll(id, attempts + 1), 100);
      return;
    }

    const navigation = document.querySelector('.navigation') as HTMLElement;
    const yOffset = navigation ? -(navigation.offsetHeight + 10) : -80;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
